import { render, staticRenderFns } from "./ConfigTeacherDialog.vue?vue&type=template&id=2a7bc39d"
import script from "./ConfigTeacherDialog.vue?vue&type=script&lang=js"
export * from "./ConfigTeacherDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfigTeacherDialog.vue?vue&type=style&index=0&id=2a7bc39d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports